import { render, staticRenderFns } from "./DiagnosticSidenav.vue?vue&type=template&id=6418bc84&"
import script from "./DiagnosticSidenav.vue?vue&type=script&lang=ts&"
export * from "./DiagnosticSidenav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports